import axios from 'axios'
import { useEffect, useState } from 'react'

import { MonitoringDedictviFetchResult } from '../../common/heritageMonitoringTypes'
import { useAppSelector } from '../../redux/hooks'

export const useFetchHeritageMonitoring = (filterQuery: string) => {
  const token = useAppSelector(state => state.myProfile.token)

  const [result, setResult] = useState<MonitoringDedictviFetchResult>({
    fetching: true,
    error: false,
    data: null,
  })
  useEffect(() => {
    const fetchData = async () => {
      try {
        setResult(prev => ({ ...prev, fetching: true }))
        const response = await axios.get(
          `https://data.regesta.cz/DrmApi/api/v1.0/MonitoringDedictvi?${filterQuery}&access_token=${token}`
        )

        setResult({
          fetching: false,
          error: false,
          data: response.data,
        })
      } catch (error) {
        setResult({
          fetching: false,
          error: true,
          data: null,
        })
      }
    }

    fetchData()
  }, [filterQuery, token])

  return result
}
